import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

const toggleSwitchStyles = makeStyles<ISpcTheme>(
  theme => ({
    root: {
      width: '42px',
      height: '26px',
      padding: 0,
      margin: 8,
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: theme.palette.primaryDisabled.main,
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: theme.palette.primary.light,
        border: `6px solid ${theme.palette.common.white}`,
      },
    },
    switchContainer: {
      display: 'flex',
      justifyContent: 'center',
      margin: '5px 0 15px',
      '& p:first-child': {
        marginRight: '20px',
      },
    },
    label: {
      fontFamily: theme.typography.fontFamily2,
      marginRight: '15px',
    },
    thumb: {
      width: '24px',
      height: '24px',
    },
    track: {
      borderRadius: '13px',
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.primaryDisabled.main,
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
    selectCurrency: {
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily2,
    },
    unselectedCurrency: {
      color: theme.palette.text.primary,
    },
    selectedCurrency: {
      fontFamily: theme.typography.fontFamily2,
      color: theme.palette.primary.main,
    },
  }),
  { name: 'ConfigSummary_currencySwitch' },
);

export default toggleSwitchStyles;
